var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('h3',[_vm._v("Select a chat to start! Or create yours. ")]),_c('chats')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }